import {
  Box,
  Button,
  Group,
  Heading,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Text,
} from '@optiaxiom/react';
import { IconArrowUpRightFromSquare } from '@optiaxiom/icons';
import { Terminal, type TerminalLine } from '@/components/ui/Terminal';
import styles from './ApiKeyActiveState.module.css';

// The key itself is shown only once at creation, so the snippet uses a
// `your-api-key` placeholder the developer swaps for their saved key.
const SCRIPT: TerminalLine[] = [
  { text: '# Save your API key to the OCP credentials file', comment: true },
  { text: 'echo \'{"apiKey": "<your-api-key>"}\' > ~/.ocp/credentials.json' },
  { text: '' },
  { text: '# Verify your account', comment: true },
  { text: 'ocp accounts whoami' },
];

export function QuickstartCard() {
  return (
    <Box bg="bg.default" className={styles.card}>
      <Group flexDirection="row" justifyContent="space-between" alignItems="start" gap="16">
        <Group flexDirection="column" gap="4" alignItems="start">
          <Heading level="2" fontWeight="700">
            Start using your API Key
          </Heading>
          <Text color="fg.secondary">
            Save your API key to the OCP credentials file, verify your account and start using the CLI commands. For more detailed instructions, check out the documentation.
          </Text>
        </Group>
        {/* TODO: point at the real docs URL. */}
        <Button appearance="default" asChild>
          <a
            href="https://docs.developers.optimizely.com/optimizely-connect-platform/docs/configure-your-development-environment-ocp2#configure-the-ocp-cli-for-mac-or-linux"
            target="_blank"
            rel="noreferrer"
          >
            View docs <IconArrowUpRightFromSquare size={14} />
          </a>
        </Button>
      </Group>

      <Box mt="16">
        <Tabs defaultValue="quickstart">
          <TabsList>
            <TabsTrigger value="quickstart">Quickstart</TabsTrigger>
          </TabsList>
          <TabsContent value="quickstart">
            <Box mt="16">
              <Terminal lines={SCRIPT} />
            </Box>
          </TabsContent>
        </Tabs>
      </Box>
    </Box>
  );
}
